import { defineMessage } from 'services/localization';

export const messages = {
    filesDragMessage: defineMessage('drag_drop_to_upload_as_files'),
    filesToSupplieDragMessage: defineMessage('drag_drop_to_upload_as_attachments_to_supplier'),
};
